import "../index.scss"
